import "../index.scss"
